<script setup lang="ts">
import type { ICompanyFeature } from '@/pages/about/model/types/companyFeatures';
import CompanyFeature from '@/pages/about/ui/CompanyFeature.vue';

const { t } = useI18n();

const features: Ref<ICompanyFeature[]> = ref([
  {
    id: 1,
    title: t('missionAndValues'),
    description: t('missionDescription'),
    image: '/images/about/missiya-i-cennosti.webp',
  },
  {
    id: 2,
    title: t('strategy'),
    description: t('strategyDescription'),
    image: '/images/about/strategiya.webp',
  },
  {
    id: 3,
    title: t('history'),
    description: t('historyDescription'),
    image: '/images/about/istoriya.webp',
  },
  {
    id: 4,
    title: t('awardsAndAchievements'),
    description: t('awardsAndAchievementsDescription'),
    image: '/images/about/nagrady-i-dostizheniya.webp',
  },
]);
</script>

<template>
  <div class="features-section">
    <ul class="features-section__list">
      <li v-for="feature in features" :key="feature.id" class="features-section__item">
        <CompanyFeature :feature="feature" />
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.features-section {
  &__list {
    display: grid;
    gap: @size-x5;
    grid-template-columns: repeat(auto-fill, minmax(47%, 1fr));
  }

  @media @1024 {
    &__list {
      gap: @size-x2;
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>
